module.exports = "/images/wing-box.svg?dfbce98f468d0e1048a4d387ead54bfa";